import { AdminActionNames, AdminActionTypes, AdminState, FileTypesRecord } from './types';

const initialState = {
  manageFileTypes: {
    classification: '',
    fileTypeId: '',
    isAutoSyncEnabled: false,
    extension: '',
    fileTypeName: '',
    isHashingEnabled: false,
    isCloudOriginated: false,
    isDefaultConfig: false,
    isRegistrationRelated: false,
    mastership: '',
    isOnDemandSupported: true,
    isPushEnabled: false,
    isShaSyncSupported: false,
    isSwapsEnabled: false,
    isTransferOverrideEnabled: false,
    defaultConfigValue: '',
    commandQueueLimit: '',
    fileTypeFamily: '',
    transferDirection: '',
  },
  autocompleteList: [],
  mastershipList: [],
  transferDirectionList: [],
  classificationList: [],
  commandQueueLimitList: [],
};

export const adminReducer = (
  state: AdminState = initialState,
  action: AdminActionTypes,
): AdminState => {
  switch (action.type) {
    case AdminActionNames.SET_MANAGE_FILE_TYPES: {
      return {
        ...state,
        manageFileTypes: action.payload,
      };
    }
    case AdminActionNames.SET_FILE_TYPE_AUTOCOMPLETE: {
      return {
        ...state,
        autocompleteList: action.payload.map(
          (fileTypeConfig: FileTypesRecord) => fileTypeConfig.fileTypeId,
        ),
        classificationList: [
          ...new Set(action.payload.map((item: FileTypesRecord) => item.classification)),
        ],
        transferDirectionList: [
          ...new Set(
            action.payload
              .filter((item: FileTypesRecord) => item.transferDirection !== null)
              .map((item: FileTypesRecord) => item.transferDirection),
          ),
        ],
        mastershipList: [
          ...new Set(
            action.payload
              .filter((item: FileTypesRecord) => item.mastership !== null)
              .map((item: FileTypesRecord) => item.mastership),
          ),
        ],
        commandQueueLimitList: [
          ...new Set(action.payload.map((item: FileTypesRecord) => item.commandQueueLimit)),
        ],
      };
    }
    case AdminActionNames.SET_ADD_NEW_FILE_TYPE_ID: {
      return {
        ...state,
        autocompleteList: [...state.autocompleteList, action.payload],
      };
    }
    default:
      return state;
  }
};
